import "./native-information.css";

// Only explicit article navigation unlocks page scrolling. Editor libraries and
// popovers own their scroll; reaching their edges cannot reveal the article.
const information = document.getElementById("creator-information");
const editor = document.getElementById("native-editor");
if (information && editor) {
  let reading = false;
  const clearArticleHash = () => {
    if (["#creator-information", "#native-editor"].includes(location.hash))
      history.replaceState(
        history.state,
        "",
        location.pathname + location.search,
      );
  };
  const setReading = (value: boolean) => {
    reading = value;
    document.documentElement.classList.toggle(
      "native-information-reading",
      value,
    );
    editor.inert = value;
    information.inert = !value;
    clearArticleHash();
    if (value) {
      information.focus({ preventScroll: true });
      information.scrollIntoView({ behavior: "instant", block: "start" });
    } else {
      window.scrollTo(0, 0);
      editor
        .querySelector<HTMLElement>("#native-overlay")
        ?.focus({ preventScroll: true });
    }
  };
  document.querySelectorAll(".creator-information-link").forEach((link) =>
    link.addEventListener("click", (event) => {
      event.preventDefault();
      setReading(true);
    }),
  );
  information.querySelectorAll("[data-return-to-editor]").forEach((link) =>
    link.addEventListener("click", (event) => {
      event.preventDefault();
      setReading(false);
    }),
  );
  window.addEventListener("hashchange", () => {
    if (["#creator-information", "#native-editor"].includes(location.hash))
      setReading(location.hash === "#creator-information");
  });
  // Reading is temporary UI state. Old bookmarked hashes, reloads and history
  // restoration must never leave the canvas inert or page scrolling unlocked.
  history.scrollRestoration = "manual";
  setReading(false);
  window.addEventListener("pageshow", () => setReading(false));
  window.addEventListener(
    "scroll",
    () => {
      if (reading && window.scrollY <= 1) setReading(false);
      else if (!reading && window.scrollY !== 0) window.scrollTo(0, 0);
    },
    { passive: true },
  );
  for (const type of ["keydown", "copy", "cut", "paste", "dragover", "drop"]) {
    window.addEventListener(
      type,
      (event) => {
        if (
          reading &&
          event instanceof KeyboardEvent &&
          event.key === "Escape"
        ) {
          event.preventDefault();
          event.stopImmediatePropagation();
          setReading(false);
          return;
        }
        if (reading || information.contains(event.target as Node)) {
          if (type === "drop" || type === "dragover") event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true,
    );
  }
}
